<template>
    <div class='story-item-container'>
        <!-- 上图（4存在，5不存在） + 标题 + 简介 -->
        <div class='story-item-4' v-if='item.templateType === 4 || item.templateType === 5'>
            <img v-if="item.imgList && item.imgList.length !== 0" v-lazy.currentpage="item.imgList[0]" @error="setDefaultImg"/>
            <div class='text-title'>{{item.title}}</div>
            <div class='text-brief'>{{item.brief}}</div>
            <div class='story-info' v-if="item.authorAvatar || item.author">
                <!-- <img :src="item.authorAvatar ? item.authorAvatar : defaultPortrait" class='author-avatar' @error="setDefaultPortrait"/> -->
                <div class='author-name'>{{item.author || "匿名用户"}}</div>
                <div class='publish-time'>{{item.publishTime | FormatPublishTime}}</div>
            </div>
        </div>
        <!-- 标题 + 三图并列 -->
        <div class='story-item-3' v-else-if='item.templateType === 3'>
          <div class='headline'>{{item.title}}</div>
          <div class='image-container'>
            <img v-for='(itemImage, indexImage) in item.imgList' v-lazy.currentpage='itemImage' :key='indexImage'/>
          </div>
          <div class='story-info' v-if="item.authorAvatar || item.author">
            <!-- <img :src="item.authorAvatar ? item.authorAvatar : defaultPortrait" class='author-avatar' @error="setDefaultPortrait"/> -->
            <div class='author-name'>{{item.author || "匿名用户"}}</div>
            <div class='publish-time'>{{item.publishTime | FormatPublishTime}}</div>
          </div>
        </div>
        <!-- 上文下图 -->
        <div class='story-item-4' v-else-if='item.templateType === 2'>
          <div class='text-title'>{{item.title}}</div>
          <img v-if="item.imgList && item.imgList.length !== 0" v-lazy.currentpage="item.imgList[0]" />
          <div class='text-brief'>{{item.brief}}</div>
          <div class='story-info' v-if="item.authorAvatar || item.author">
            <!-- <img :src="item.authorAvatar ? item.authorAvatar : defaultPortrait" class='author-avatar' @error="setDefaultPortrait"/> -->
            <div class='author-name'>{{item.author || "匿名用户"}}</div>
            <div class='publish-time'>{{item.publishTime | FormatPublishTime}}</div>
          </div>
        </div>
        <div class='story-item-1' v-else>
          <div class='item-1-left'>
            <img v-if="item.imgList && item.imgList.length !== 0" v-lazy.currentpage="item.imgList[0]" @error='setDefaultItem'/> 
          </div>
          <div class='item-1-right'>
            <div class='headline'>{{item.title}}</div>
            <div class='text-brief'>{{item.brief}}</div>
            <div class='story-info' v-if="item.authorAvatar || item.author">
              <!-- <img :src="item.authorAvatar ? item.authorAvatar : defaultPortrait" class='author-avatar' @error="setDefaultPortrait"/> -->
              <div class='author-name'>{{item.author || "匿名用户"}}</div>
              <div class='publish-time'>{{item.publishTime | FormatPublishTime}}</div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
          defaultPortrait: require('../assets/default_portrait.png'),
          defaultItem: require('../assets/default_item.png'),
          defaultImg: require('../assets/default_img.png'),
        }
    },
    props: {
        item: {
            type: Object,
            default: {},
        }
    },
    methods: {
      setDefaultPortrait (e) {
        e.srcElement.src = this.defaultPortrait;
        // 防止默认图片也加载不了
        e.srcElement.onerror = null;
      },
      setDefaultItem (e) {
        e.srcElement.src = this.defaultItem;
        e.srcElement.onerror = null
      },
      setDefaultImg (e) {
        e.srcElement.src = this.defaultImg;
        e.srcElement.onerror = null;
      }
    }
}
</script>

<style scoped>
.story-item-container {
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  padding: 12px 0;
  margin: 0 8px;
  overflow: hidden;
  text-align: left;
  font-size: 17px;
}
.story-item-4 img {
  width: 100%;
  border-radius: 4px;
}
.story-item-4 .text-title {
  font-size: 17px;
  padding: 4px 0;
}
.story-item-4 .text-brief {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  /* 设置显示多少行 */
  -webkit-line-clamp: 3; 
  display: -webkit-box;
  /* display: flex; flex布局不行 */
}
.story-info {
  display: flex;
  align-items: center;
  padding: 4px 0;
}
.story-info .author-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.story-info .author-name {
  flex-grow: 1;
  /* padding-left: 4px; */
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
}
.story-info .publish-time {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
}

.story-item-3 {

}
.story-item-3 .image-container {
  /* display为flex时，只设置直接子元素img的width不会等比列缩放height */
  display: block;
  /* text-align: center; */
  padding-top: 4px;
}
.image-container img {
  width: 32%;
  margin-left: 5px;
  border-radius: 4px;
}
.image-container img:first-child {
  margin-left: 0;
}
.story-item-1 {
  /* display为flex时，只设置非直接子元素img的width会等比列缩放height */
  display: flex;
  align-items: flex-start;
}
.story-item-1 .item-1-left {
  width: 32%;
  flex-shrink: 0;
}
.item-1-right .headline {
  font-size: 17px;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  /* 设置显示多少行 */
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow: hidden; 
}
.item-1-left .text-brief {
  font-size: 16px;
}
.item-1-left img {
  /* 占父级元素的宽度 */
  width: 100%;
  /* 避免img比父级元素高5px，参考 https://jingyan.baidu.com/article/148a1921e4ed0f4d71c3b12d.html */
  vertical-align: top;
  border-radius: 4px;
}
.story-item-1 .item-1-right {
  padding-top: 4px;
  box-sizing: border-box;
  padding-left: 10px;
  /* flex-grow: 1; */
  flex-shrink: 0;
  width: 67%;
}
.story-item-1 .story-info {
  padding: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ListItemComponent.vue